import React from "react";
import { Grid, Box, Button, Typography } from "@mui/material";
import HiringExcellenceleftIcon from "./../../../assets/images/HiringExcellence/HiringExcellenceleftIcon.svg";
import HiringExcellenceRightIcon from "./../../../assets/images/HiringExcellence/HiringExcellenceRightIcon.svg";

const HiringExcellence: React.FC = () => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        height: "calc(100vh - 4rem)", // Reduce overall height
        padding: "1rem 2rem", // Adjust padding to reduce top/bottom gap
        backgroundColor: "#FDFDFD",
        border: "1px solid #E0E0E0",
      }}
      mt={1}
    >
      {/* Left Image */}
      <Grid
        item
        xs={12}
        sm={4}
        md={3}
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Box
          component="img"
          src={HiringExcellenceleftIcon}
          sx={{
            height: "100%", // Set height explicitly
            maxHeight: "400px", // Optional: Adjust the max height for responsiveness
            width: "auto", // Maintain aspect ratio
          }}
        />
      </Grid>

      {/* Center Content */}
      <Grid
        item
        xs={12}
        sm={4}
        md={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: { xs: "1rem", md: "2rem" }, // Adjust padding for smaller screens
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 500,
            color: "#000000",
            marginBottom: "1rem",
            fontSize: { xs: "24px", md: "32px" }, // Adjust font size for smaller screens
          }}
        >
          Achieve hiring excellence <br /> through AI-driven tools
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#666666",
            marginBottom: "2rem",
            fontSize: { xs: "16px", md: "20px" }, // Adjust font size for smaller screens
          }}
        >
          Discover how Eximius AI can elevate your
          <br /> recruitment strategy. Ready to see it in action?
        </Typography>
         <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#3a55f2",
                    color: "#ffffff",
                    fontWeight: "bold",
                    textTransform: "none",
                    padding: "0.75rem 1.5rem",
                    borderRadius: "8px",
                    ":hover": {
                      backgroundColor: "#1a1a1a",
                      boxShadow: "0px 0px 10px 3px rgba(94, 137, 214)",
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  Book a Free Demo
                </Button>
      </Grid>

      {/* Right Background Design */}
      <Grid
        item
        xs={12}
        sm={4}
        md={3}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Box
          component="img"
          src={HiringExcellenceRightIcon}
          sx={{
            height: "100%", // Set height explicitly
            maxHeight: "400px", // Optional: Adjust the max height for responsiveness
            width: "auto", // Maintain aspect ratio
          }}
        />
      </Grid>
    </Grid>
  );
};

export default HiringExcellence;
